var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwolines27(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.01 27.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40.01,
    height: 6.59,
    rx: 3.29,
    ry: 3.29
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21.02,
    width: 40.01,
    height: 6.59,
    rx: 3.29,
    ry: 3.29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwolines27);
export default __webpack_public_path__ + "static/media/two lines-27.5adf45ab996d9975af120242f7193a67.svg";
export { ForwardRef as ReactComponent };